// 人员稳定
import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import { Table } from 'antd'
import columns from './columns'
const { WizSpin, WizButton, WizModal, WizCard } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

import CounselingHeader from '../../header'
import './index.less'

const findParamRecord = (history) => {
  let record = {}
  if (history.location && history.location.pathname === '/integrationCounseling/manager/track/personnelStability') {
    if (history.location && history.location.record) {
      record = history.location.record
      Session.set('trackPersonnelStability', record)
    } else {
      record = Session.get('trackPersonnelStability') || {}
    }
  }
  return record
}

class TrackPersonnelStability extends WizContainer {

  componentName = 'TrackPersonnelStability'

  constructor(props) {
    super(props)
    let record = findParamRecord(props.history)
    this.state = {
      record,
      data: []
    }
  }

  _componentDidMount() {
    this.getList()
  }

  getList = () => {
    const { processContentId, tutorId } = this.state.record
    this.doAction({
      path: 'counselingProcess/trackStableList',
      payload: {
        key: 'trackStableList@' + processContentId,
        apiParams: {
          tutorId: tutorId,
          tutorContentId: processContentId
        }
      }
    })
  }

  toUpdate = () => {
    const { processContentId, tutorId } = this.state.record
    this.doAction({
      path: 'counselingProcess/trackStableLatestList',
      payload: {
        key: 'trackStableLatestList@' + processContentId,
        apiParams: {
          tutorId: tutorId,
          tutorContentId: processContentId,
        }
      }
    })
  }

  markConfirmed = () => {
    const { processContentId, tutorId } = this.state.record
    this.doAction({
      path: 'counselingProcess/trackStableNoticeTargetConfirm',
      payload: {
        key: 'trackStableNoticeTargetConfirm@' + processContentId,
        apiParams: {
          tutorId: tutorId,
          tutorContentId: processContentId
        }
      }
    })
  }

  _onBtn = (type) => {
    switch (type) {
      case 1:
        this.toUpdate()
        break
      case 2:
        WizModal.confirm({
          title: '注意',
          content: '是否确认进行达标确认操作？',
          onOk: () => {
            this.markConfirmed()
          },
          onCancel() {
          }
        })
        break
      default:
        break
    }
  }

  propsAndStateOnChange = {
    list: this._getList.bind(this),
    markConfirmed: this._markConfirmed.bind(this),
    toUpdate: this._toUpdate.bind(this),
  }

  _getList(nextProps, nextState) {
    let { list } = nextProps
    let { success, msg, data } = list
    if (success) {
      nextState.data = data
      return true
    }
    wizNotice.error(msg || '获取人员稳定列表失败')
    return false
  }

  _toUpdate(nextProps, nextState) {
    let { toUpdate } = nextProps
    let { success, msg, data } = toUpdate
    if (success) {
      nextState.data = data
      return true
    }
    wizNotice.error(msg || '更新人员稳定列表失败')
    return false
  }

  _markConfirmed(nextProps, nextState) {
    let { markConfirmed } = nextProps
    let { success, msg } = markConfirmed
    if (success) {
      wizNotice.success(msg)
      this.jumpPage('goBack')
      return true
    }
    wizNotice.error(msg || '达标确认失败')
    return false
  }



  render() {
    let { counselingProcessLoading } = this.props
    let { record, data } = this.state
    let { processContentState } = record
    let tableProps = {
      columns: columns(),
      dataSource: data,
      pagination: false,
      bordered: true,
      rowKey: (e, i) => i
    }

    return (
      <WizSpin spinning={counselingProcessLoading} >
        <CounselingHeader record={record} />
        <WizCard title='人员稳定'>
          <div style={{ marginBottom: 20 }}>
            <WizButton
              type='primary'
              disabled={processContentState === 1}
              style={{ marginRight: 15 }}
              onClick={() => this._onBtn(1)}>
              {'更新'}
            </WizButton>
            <WizButton
              type='primary'
              disabled={processContentState === 1 || data.length === 0}
              onClick={() => this._onBtn(2)}>
              {'达标确认'}
            </WizButton>
          </div>
          <Table {...tableProps} />
        </WizCard>
      </WizSpin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { counselingProcess } = state
  const { processContentId } = findParamRecord(ownProps.history)
  const list = modelUtils.getModelEntity(counselingProcess, 'trackStableList@' + processContentId)
  const toUpdate = modelUtils.getModelEntity(counselingProcess, 'trackStableLatestList@' + processContentId) // 更新
  const markConfirmed = modelUtils.getModelEntity(counselingProcess, 'trackStableNoticeTargetConfirm@' + processContentId) // 达标确认
  const loading = modelUtils.getLoadingState(state, 'counselingProcess')
  return {
    list,
    markConfirmed,
    toUpdate,
    ...loading
  }
}

export default connect(mapStateToProps)(TrackPersonnelStability)



